import { useTranslation } from 'react-i18next'

import { BoxProps, Fade, VStack } from '@chakra-ui/react'

import PlusIcon from '@wwt/shared/assets/icons/outline/plus.svg'

import { QuickActionButton } from './QuickActionButton'

interface SetChangePopup extends BoxProps {
	sets: string[]
	isOpen: boolean
}

export const SetChangePopup = ({
	sets,
	isOpen,
	...boxProps
}: SetChangePopup) => {
	const { t } = useTranslation('tooltips')
	return (
		// @ts-expect-error Chakra v2 bug with types on react 19
		<Fade
			in={isOpen}
			style={{
				position: 'absolute',
				left: '24.725rem',
				bottom: '0',
				zIndex: 'var(--chakra-zIndices-tooltip)',
				display: isOpen ? 'block' : 'none'
			}}
		>
			<VStack
				w="15.125rem"
				borderWidth="0.0625rem"
				borderColor="gray.200"
				borderRadius="md"
				boxShadow="0 0.125rem 0.75rem 0 #00000040"
				bg="white"
				{...boxProps}
			>
				{sets.map((setName, i) => (
					<QuickActionButton
						// FIXME: index key
						// eslint-disable-next-line react/no-array-index-key
						key={i}
						text={setName}
						borderTopRadius={i === 0 ? 'md' : '0'}
						borderBottomRadius="0"
						zIndex="tooltip"
					/>
				))}
				<QuickActionButton
					text={t('reasonPopup.createSet')}
					icon={PlusIcon}
					borderTopRadius="0"
					borderBottomRadius="md"
				/>
			</VStack>
		</Fade>
	)
}
